import React, { useState } from 'react';
import "./TextModal.css";

const TextModal = ({ isOpen, onClose, content, onCreate, title, position = {}, placeholder }) => {
    const [description, setDescription] = useState('');

  if (!isOpen) return null;

  const defaultStyles = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    width: '300px',
  };

  const modalStyles = {
    ...defaultStyles,
    ...position, // Override default styles with custom position
  };

  const handleCreate = () => {
    onCreate(description); // Pass the description to the parent handler
    setDescription(''); // Reset the input
    onClose(); // Close the modal
  };

  return (
    <div className="mr-modal">
      <div className="modal-content"  style={modalStyles}>
        <h2>{title}</h2>
        <input
          type="text"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="modal-input"
          placeholder={placeholder || ""}
        />
        <div className="modal-actions">
          <button onClick={onClose} className="modal-btn modal-cancel">
            Cancel
          </button>
          <button onClick={handleCreate} className="modal-btn modal-create">
            Create
          </button>
        </div>
      </div>
    </div>
  );
};
  

export default TextModal
